import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-view" }
const _hoisted_2 = { class: "map-view-controls" }
const _hoisted_3 = { class: "date-view-controls mt-2" }
const _hoisted_4 = { class: "d-flex flex-row align-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "d-flex flex-row align-center my-2" }
const _hoisted_7 = { class: "map-dropdown-container d-flex flex-row flex-wrap" }

import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { DatePickerInstance } from "@vuepic/vue-datepicker";
import { supportsTouchscreen } from "@cosmicds/vue-toolkit";

import { type MoleculeType } from "@/esri/utils";
import { useTempoStore } from "@/stores/app";
import { useEsriTimesteps } from "@/composables/useEsriTimesteps";

import TimeChips from "@/components/TimeChips.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapControls',
  emits: ["molecule"],
  setup(__props, { emit: __emit }) {

const store = useTempoStore();
const {
  timestamps,
  singleDateSelected,
  uniqueDays,
  selectedTimezone,
  timezoneOptions,
  timeIndex,
  minIndex,
  maxIndex,
} = storeToRefs(store);

const emit = __emit;

const molecule = ref<MoleculeType>('no2');
const { esriTimesteps } = useEsriTimesteps(molecule);

const radio = ref<number | null>(null);
const touchscreen = supportsTouchscreen();

const calendar = ref<DatePickerInstance | null>(null);

function handleEsriTimeSelected(ts: number, _index: number) {
  const idx = timestamps.value.indexOf(ts);
  console.log(`ESRI time selected: ${new Date(ts)} (nearest index ${idx})`);
  if (idx >= 0) {
    timeIndex.value = idx;
  }
  // We may need something like this when we get back the monthly average service.
  //singleDateSelected.value = new Date(ts);
}

watch(molecule, (newMol: MoleculeType) => {
  emit("molecule", newMol);
});

return (_ctx: any,_cache: any) => {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Explore Map View", -1)),
    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "my-2" }, "Select a date, timezone, and molecule to display", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_radio_group, {
            modelValue: radio.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((radio).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_date_picker, {
                class: "ddrp__date-picker tall",
                ref_key: "calendar",
                ref: calendar,
                "model-value": _unref(singleDateSelected),
                onInternalModelChange: _cache[2] || (_cache[2] = (value) => {
                if (value != null && value.getTime() != _unref(singleDateSelected).getTime()) {
                  radio.value = null;
                  singleDateSelected.value = value;
                  calendar.value?.closeMenu();
                }
              }),
                "allowed-dates": _unref(uniqueDays),
                clearable: false,
                "enable-time-picker": false,
                "multi-dates": false,
                transitions: false,
                format: (date) => date?.toDateString(),
                "preview-format": (date) => date?.toDateString(),
                "week-start": 0,
                "no-today": "",
                dark: "",
                "year-range": [_unref(uniqueDays)[0]?.getFullYear(), _unref(uniqueDays)[_unref(uniqueDays).length - 1]?.getFullYear()],
                "six-weeks": ""
              }, {
                "action-buttons": _withCtx(() => [
                  _createElementVNode("button", {
                    class: "dp__action_button dp__action-latest",
                    onClick: _cache[0] || (_cache[0] = () => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1]),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(() => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1], ["enter"])),
                    disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                    elevation: "0",
                    size: "sm"
                  }, " Latest ", 40, _hoisted_5)
                ]),
                _: 1
              }, 8, ["model-value", "allowed-dates", "format", "preview-format", "year-range"]),
              (molecule.value.toLowerCase().includes('month'))
                ? (_openBlock(), _createBlock(TimeChips, {
                    key: 0,
                    timestamps: _unref(esriTimesteps).slice(_unref(minIndex), _unref(maxIndex) + 1),
                    onSelect: _cache[3] || (_cache[3] = ($event: any) => (handleEsriTimeSelected($event.value, $event.index))),
                    "selected-index": _unref(timeIndex) - _unref(minIndex),
                    "use-utc": molecule.value.toLowerCase().includes('month'),
                    "date-only": molecule.value.toLowerCase().includes('month'),
                    "hour-only": !molecule.value.toLowerCase().includes('month')
                  }, null, 8, ["timestamps", "selected-index", "use-utc", "date-only", "hour-only"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_tooltip, {
            disabled: _unref(touchscreen),
            text: "Previous Date"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                class: "rounded-icon-wrapper",
                onClick: _unref(store).moveBackwardOneDay,
                onKeyup: _withKeys(_unref(store).moveBackwardOneDay, ["enter"]),
                disabled: _unref(singleDateSelected) === _unref(uniqueDays)[0],
                color: "#009ade",
                variant: "outlined",
                elevation: "0",
                size: "md"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-chevron-double-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16, ["onClick", "onKeyup", "disabled"])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_tooltip, {
            disabled: _unref(touchscreen),
            text: "Get Data for latest available day"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                style: {"padding-inline":"4px"},
                onClick: _cache[5] || (_cache[5] = () => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1]),
                onKeyup: _cache[6] || (_cache[6] = _withKeys(() => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1], ["enter"])),
                disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                color: "#009ade",
                variant: "outlined",
                elevation: "0",
                size: "md"
              }), {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Latest Data ", -1)
                ]))]),
                _: 1
              }, 16, ["disabled"])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_tooltip, {
            disabled: _unref(touchscreen),
            text: "Next Date"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                class: "rounded-icon-wrapper",
                onClick: _unref(store).moveForwardOneDay,
                onKeyup: _withKeys(_unref(store).moveForwardOneDay, ["enter"]),
                disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                color: "#009ade",
                variant: "outlined",
                elevation: "0",
                size: "md"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-chevron-double-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16, ["onClick", "onKeyup", "disabled"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_select, {
          modelValue: _unref(selectedTimezone),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(selectedTimezone) ? (selectedTimezone).value = $event : null)),
          class: "map-dropdowns timezone-dropdown",
          label: "Timezone",
          items: _unref(timezoneOptions),
          "item-title": "name",
          "item-value": "tz",
          "hide-details": "",
          dense: "",
          variant: "outlined"
        }, null, 8, ["modelValue", "items"])
      ])
    ])
  ]))
}
}

})